import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useAddClient = () => {
  return usePost({ url: ApiRoutesEnum.addClient });
};
